<h1 mat-dialog-title>{{ 'CHAT_SUMMARY.TITLE' | translate }}</h1>
<div mat-dialog-content>
  <div>
    <p>{{ 'CHAT_SUMMARY.CONTENT' | translate }}</p>
  </div>

  <form #summaryForm="ngForm" (ngSubmit)="onSubmit(summaryForm)">
    <div class="form-container">

      <div class="form-group">
        <mat-form-field>
          <mat-label>{{ 'GENERAL.START_DATE' | translate }}</mat-label>
          <input matInput [matDatepicker]="startDate" name="startDate" [(ngModel)]="defaultStartDate" required>
          <mat-datepicker #startDate />
          <mat-datepicker-toggle [for]="startDate" matSuffix />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ 'GENERAL.START_TIME' | translate }}</mat-label>
          <input matInput [matTimepicker]="startTime" name="startTime" [(ngModel)]="defaultStartTime">
          <mat-timepicker #startTime />
          <mat-timepicker-toggle [for]="startTime" matSuffix />
        </mat-form-field>
      </div>

      <div class="form-group">
        <mat-form-field>
          <mat-label>{{ 'GENERAL.END_DATE' | translate }}</mat-label>
          <input matInput [matDatepicker]="endDate" name="endDate" ngModel>
          <mat-datepicker #endDate />
          <mat-datepicker-toggle [for]="endDate" matSuffix />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ 'GENERAL.END_TIME' | translate }}</mat-label>
          <input matInput [matTimepicker]="endTime" name="endTime" ngModel>
          <mat-timepicker #endTime />
          <mat-timepicker-toggle [for]="endTime" matSuffix />
        </mat-form-field>
      </div>

      <div class="from-group button-container">
        @if (!isLoading) {
          <button mat-button type="submit" #actionButton>{{ 'CHAT_SUMMARY.BUTTON' | translate }}</button>
        }
        @if (isLoading) {
          <mat-spinner diameter="28" style="width: 50px"></mat-spinner>
        }
      </div>
    </div>
  </form>

  <div class="result-container">
    <label for="summary">{{ 'CHAT_SUMMARY.RESULT' | translate }}</label>
    <textarea id="summary" [(ngModel)]="summary" readonly></textarea>
  </div>

  <div class="media-gallery">
    @for (file of files; track file) {
      <div class="media-container">
        @if (file.mediaType == mediaTypeEnum.Image) {
          <div> <img [src]="file.url" class="media" (click)="openMediaModal(file.url!, file.mediaType)"> </div>
        }
        @if (file.mediaType == mediaTypeEnum.Video) {
          <div> <video [src]="file.url" class="media" (click)="openMediaModal(file.url, file.mediaType)"></video> </div>
        }
        @if (file.mediaType == mediaTypeEnum.Audio) {
          <div> <img src="/assets/images/filetypes/audio.svg" class="media" (click)="openMediaModal(file.url, file.mediaType)"> </div>
        }
        @if (file.mediaType == mediaTypeEnum.Document) {
          <div> <img src="/assets/images/filetypes/file.svg" class="media" (click)="downloadFile(file.url)"> </div>
        }
        @if (file.mediaType == mediaTypeEnum.CompressedFile) {
          <div> <img src="/assets/images/filetypes/zip.png" class="media" (click)="downloadFile(file.url)"> </div>
        }
      </div>
    }
  </div>

</div>
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]>{{ 'MODAL.CLOSE' | translate }}</button>
</div>
